/* eslint-disable no-unused-vars, max-len */
const { feWp } = window;
const { addAction } = feWp.hooks;


addAction(
  'b3rg_slider_init',
  'b3rg/slider',
  ( settings, el, swiper ) => {
    const ratingCards = document.querySelectorAll( 
      '.e-stn--rating-cards .swiper-slide .e-div--top-content-wrapper' 
    );
    const calcHeights = () => {
      const maxHeight = Math.max( ...Array.from( ratingCards ).map( card => card.offsetHeight ) );
      
      ratingCards.forEach( card => {
        card.style.height = `${maxHeight}px`;
      } );
    };
    if ( ratingCards.length > 0 ) {
      calcHeights();
    }
  },
  10,
  1,
);